import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { APP_SECTION_LIST } from 'src/constants/queryKeys';

export const networkGetAppSectionInfo = async (appSectionId) => {
  const res = await axiosInstance.post(`ApplicationSection/Info/${appSectionId}`);
  return res;
};

export function useFetchAppSectionInfo(appSectionId) {
  return useQuery({
    queryKey: ['app-section-info', appSectionId],
    queryFn: () => networkGetAppSectionInfo(appSectionId),
  });
}

export const networkGetAppSectionList = async (pageIndex = 0, pageSize = 30, appId) => {
  const res = await axiosInstance.post(`ApplicationSection/ListPanel/${pageIndex}/${pageSize}/${appId}`);
  return res;
};

export function useFetchAppSectionList(pageIndex = 0, pageSize = 50, appId) {
  return useQuery({
    queryKey: [APP_SECTION_LIST, appId, pageIndex],
    queryFn: () => networkGetAppSectionList(pageIndex, pageSize, appId),
  });
}

export const networkCreateAppSection = async (data) => {
  const res = await axiosInstance.post('ApplicationSection/Insert', data);
  return res;
};

export const networkUpdateAppSection = async (appSectionId, data) => {
  const res = await axiosInstance.post(`ApplicationSection/Update/${appSectionId}`, data);
  return res;
};

export const networkRemoveAppSection = async (appSectionId) => {
  const res = await axiosInstance.post(`ApplicationSection/Remove/${appSectionId}`);
  return res;
};
